namespace $ {
	$mol_style_define( $shm_hitalama_text_link, {
		display: 'inline',
		whiteSpace: 'normal',
		overflowWrap: 'anywhere',
	} )
}
